import { Helmet } from 'react-helmet-async';

const defaults = {
  siteName: 'Propel Sports NC',
  siteUrl: 'https://www.propelsportsnc.com',
  image: 'https://customer-assets.emergentagent.com/job_multi-sport-hub-7/artifacts/cr0r96t8_Propel%20-%20Orange_refined.png',
};

export default function SEO({ title, description, path = '/', image }) {
  const fullTitle = title ? `${title} | ${defaults.siteName}` : `${defaults.siteName} — Apex's Indoor Multi-Sport Home`;
  const desc = description || "Indoor multi-sport facility in Apex, NC. Birthday parties, batting tunnels, soccer/futsal, tournaments, and facility rentals. Book today!";
  const url = `${defaults.siteUrl}${path}`;
  const img = image || defaults.image;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={defaults.siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
